export const faqInterface = [
  'answer',
  'question',
  'order'
]
